import React from 'react';
import { useRouter } from 'next/router';

import { Icon } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './MoreFromHuzzle.module.scss';

interface MoreFromHuzzleProps {
  copyLink: () => void;
  openQRModal: () => void;
  copyInviteLink: () => void;
}

export const MoreFromHuzzle: React.FC<MoreFromHuzzleProps> = (
  props: MoreFromHuzzleProps
) => {
  const { copyLink, openQRModal, copyInviteLink } = props;

  const router = useRouter();

  const exploreSocieties = () => {
    router.push(PAGE_ROUTES.STUDENT_SOCIETIES);
  };

  return (
    <div className={styles.MoreFromHuzzle}>
      <p className={styles.MoreFromHuzzleHeader}>More from Huzzle</p>
      <div className={styles.MoreFromHuzzleContent}>
        <div className={styles.container}>
          <div className={styles.details}>
            <Icon iconName="icon_megaphone" className={styles.containerIcon} />
            <div className={styles.info}>
              <p className={styles.title}>Share your profile</p>
              <p className={styles.caption}>
                Convert your members to subscribers to automatically notify them
                about your posts.
              </p>
            </div>
          </div>
          <div className={styles.action}>
            <ButtonV3 color="secondary" onClick={copyLink}>
              Copy link
            </ButtonV3>
            <ButtonV3 color="secondary" onClick={openQRModal}>
              Show QR code
            </ButtonV3>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.container}>
          <div className={styles.details}>
            <Icon iconName="icon_compass" className={styles.containerIcon} />
            <div className={styles.info}>
              <p className={styles.title}>Explore societies</p>
              <p className={styles.caption}>
                Discover and message active societies on our student societies
                page for collaborations.
              </p>
            </div>
          </div>
          <div className={styles.action}>
            <ButtonV3 color="secondary" onClick={exploreSocieties}>
              Explore societies
            </ButtonV3>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.container}>
          <div className={styles.details}>
            <Icon iconName="icon_users" className={styles.containerIcon} />
            <div className={styles.info}>
              <p className={styles.title}>Add committee members</p>
              <p className={styles.caption}>
                Copy the link below and send it to your committee so they can
                sign up.
              </p>
            </div>
          </div>
          <div className={styles.action}>
            <ButtonV3 color="secondary" onClick={copyInviteLink}>
              Copy invite link
            </ButtonV3>
          </div>
        </div>
      </div>
    </div>
  );
};
